import React from "react";
import { RouteObject } from "../../interfaces/navigation";

const EntryPoint = React.lazy(() => import("../../containers/Users/EntryPointContainer"));

export const usersRoutes: RouteObject[] = [
    {
        title: "users",
        path: "/users",
        component: <EntryPoint />,
        protected: true
    }
];